const { $config, $env } = require('./schema');
const identity = require('./identity');
const fromEnv = require('./fromEnv');

// `local` differs from the Doppler `dev` config only in these non-secret,
// localhost-specific values. (dev/staging/prod come entirely from Doppler.)
const localOverrides = {
    appleOauthClientIdWeb: 'localhost.justsalad.order',
    appleOauthRedirectUri: 'https://order.localjustsalad.dev',
    hCaptchaSiteKeyWeb: '5018b199-7dba-4275-99f5-1c009936f582'
};

const envResult = $env.safeParse(process.env.EXPO_PUBLIC_ENVIRONMENT);

if (!envResult.success) {
    console.error('invalid or missing EXPO_PUBLIC_ENVIRONMENT variable');
    console.error(envResult.error);
    throw new Error('[app.config/bootstrap] invalid or missing EXPO_PUBLIC_ENVIRONMENT');
}

const env = envResult.data;

// Build identity stays in source; everything else comes from EXPO_PUBLIC_* vars
// (Doppler-injected). If a var is missing the zod parse below reports it clearly.
const config = withOverrides({ ...identity[env], ...fromEnv() });

const configResult = $config.safeParse(config);

// this gives better errors if the config is malformed, otherwise there's just a silent exception
if (!configResult.success) {
    console.error(configResult.error.flatten());
    console.error(`ENVIRONMENT: ${env}`);
    console.error('CONFIG FILE:');
    console.error(JSON.stringify({ config }, null, 2));
    throw new Error('[app.config/boostrap] Missing or malformed config variables');
}

module.exports = configResult.data;

function withOverrides(config) {
    const withLocal = env === 'local' ? { ...config, ...localOverrides } : config;

    switch (env) {
        case 'production':
        case 'staging':
            return withLocal;
        default:
            break;
    }

    const e2eTestingOverride = process.env.EXPO_PUBLIC_OVERRIDE_E2E_TESTING;
    const justSaladSecretKey = process.env.EXPO_PUBLIC_JUSTSALAD_SECRET_KEY;
    const automatedTestKey = process.env.EXPO_PUBLIC_JUSTSALAD_AUTOMATED_TEST_KEY;
    const e2eTesting =
        e2eTestingOverride !== '' && e2eTestingOverride !== undefined
            ? e2eTestingOverride === 'true'
            : env === 'test' || withLocal.e2eTesting;

    return {
        ...withLocal,
        e2eTesting,
        justSaladSecretKey,
        automatedTestKey,
        // these can come through as the empty string in NextJS environments so we need to use
        // || rather than ??
        apiBaseUrl: process.env.EXPO_PUBLIC_OVERRIDE_API_URL || withLocal.apiBaseUrl
    };
}
